import {
  FormLayout,
  LoadingButton,
  PageLayout,
  InputControl,
} from 'components/custom';
import { Form } from 'components/shadcn';
import { version } from '../../../../package.json';
import { usePageDeviceConfig } from '../hooks';

export const PageDeviceConfig = () => {
  const { form, state, isDeviceDetailsFetching, onSubmit, onResetFormData } =
    usePageDeviceConfig();
  const isSubmitButtonLoading =
    state.isSubmitButtonLoading || isDeviceDetailsFetching;

  return (
    <PageLayout>
      <FormLayout image={state.logoUrl}>
        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="p-6 md:p-8 min-h-[350px] flex items-center justify-center"
          >
            <div className="flex flex-col space-y-4 w-full">
              <InputControl
                form={form}
                type="autocomplete"
                label="Store"
                name="store"
                placeholder="Select Store"
                options={state.storeList}
                disabled={state.isVerified}
              />
              {/* Rest of the form fields remain the same */}
              <InputControl
                form={form}
                type="password"
                label="Access Code"
                name="accessCode"
                autoComplete="off"
                disabled={state.isVerified}
              />

              {state.isVerified && (
                <InputControl
                  form={form}
                  type="autocomplete"
                  label="Device"
                  name="device"
                  placeholder="Select Device"
                  options={state.deviceList}
                />
              )}

              <LoadingButton
                type="submit"
                className="w-full"
                loading={isSubmitButtonLoading}
              >
                Confirm
              </LoadingButton>
              {state.isVerified && (
                <LoadingButton
                  type="button"
                  variant="destructive"
                  className="w-full"
                  onClick={onResetFormData}
                >
                  Reset
                </LoadingButton>
              )}

              <div className="text-center text-sm text-muted-foreground">
                v{version}
              </div>
            </div>
          </form>
        </Form>
      </FormLayout>
    </PageLayout>
  );
};
